/**
 * HORSE WISHLIST SYSTEM — FINAL STABLE BUILD
 * Louievale Equine
 */

class HorseWishlistSystem {
  constructor() {
    this.customerId = window.customerId || null;
    this.horses = [];
    this.wishlists = {};
    this.init();
  }

  /* ---------------------------
     INIT
  ---------------------------- */

  init() {
    if (!this.customerId) {
      this.addWishlistButtons(true);
      return;
    }

    this.loadData();
    this.addWishlistButtons(false);

    document.addEventListener('shopify:section:load', () => {
      this.addWishlistButtons(false);
    });
  }

  /* ---------------------------
     STORAGE
  ---------------------------- */

  loadData() {
    this.horses = JSON.parse(localStorage.getItem(`horses_${this.customerId}`)) || [];
    this.wishlists = JSON.parse(localStorage.getItem(`wishlists_${this.customerId}`)) || {};
  }

  saveData() {
    localStorage.setItem(`horses_${this.customerId}`, JSON.stringify(this.horses));
    localStorage.setItem(`wishlists_${this.customerId}`, JSON.stringify(this.wishlists));
  }

  /* ---------------------------
     HEART BUTTONS
  ---------------------------- */

  addWishlistButtons(guestMode) {
    document.querySelectorAll('.card').forEach(card => {
      if (card.querySelector('.wishlist-heart')) return;

      const media = card.querySelector('.card__media');
      const link = card.querySelector('a[href*="/products/"]');

      if (!media || !link) return;

      const handle = link.href.split('/products/')[1].split('?')[0];
      const heart = this.createHeart(handle, guestMode);

      card.style.position = 'relative';
      heart.classList.add('wishlist-heart--overlay');

      card.appendChild(heart);
    });
  }


  createHeart(handle, guestMode) {
    const btn = document.createElement('div');
    btn.className = 'wishlist-heart';
    btn.dataset.product = handle;

    btn.innerHTML = this.heartSVG(this.isInAnyList(handle));

    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      if (guestMode) {
        this.showLoginPrompt();
      } else {
        this.openSelector(handle);
      }
    });

    return btn;
  }

  updateHearts() {
    document.querySelectorAll('.wishlist-heart').forEach(btn => {
      const handle = btn.dataset.product;
      btn.innerHTML = this.heartSVG(this.isInAnyList(handle));
    });
  }

  heartSVG(active) {
    return `
      <svg class="wishlist-heart-icon ${active ? 'active' : ''}" viewBox="0 0 24 24">
        <path d="M12 21s-7-4.35-9.5-7.05C-1 9.8 2.2 3.5 7.2 3.5c2.1 0 3.6 1.2 4.8 2.7
                 1.2-1.5 2.7-2.7 4.8-2.7 5 0 8.2 6.3 4.7 10.45C19 16.65 12 21 12 21"
              fill="none" stroke-width="1.8" />
      </svg>
    `;
  }

  /* ---------------------------
     CHECKS
  ---------------------------- */

  isInAnyList(handle) {
    return Object.values(this.wishlists).some(list => list.includes(handle));
  }

  /* ---------------------------
     MODALS
  ---------------------------- */

  openSelector(handle) {
  let html = `<h3>Add to Wishlist</h3>`;

  this.horses.forEach(horse => {
    const inList = this.wishlists[horse.id]?.includes(handle);
    html += `
      <button class="wishlist-option ${inList ? 'selected' : ''}"
        onclick="horseWishlist.toggleHorse('${horse.id}','${handle}')">
        ${horse.image ? `<img src="${horse.image}" class="wishlist-horse-avatar" />` : this.horseIcon()}
        ${inList ? 'Remove from' : 'Add to'} ${horse.name}
      </button>
    `;
  });

  html += `
    <div class="wishlist-divider"></div>

    <button class="wishlist-option"
      onclick="horseWishlist.openAddHorse('${handle}')">
      ${this.plusIcon()} Add New Horse
    </button>

    <button class="wishlist-option"
      onclick="horseWishlist.toggleGift('${handle}')">
      ${this.giftIcon()}
      ${this.wishlists.gifts?.includes(handle) ? 'Remove from Gift List' : 'Add to Gift List'}
    </button>

    <div class="wishlist-helper">
      If it’s not for your horse, add it to a gift list
    </div>
  `;

  this.showModal(html);
}

  toggleHorse(horseId, handle) {
  this.wishlists[horseId] ||= [];

  const list = this.wishlists[horseId];
  const index = list.indexOf(handle);

  if (index > -1) {
    list.splice(index, 1);
  } else {
    list.push(handle);
  }

  this.saveData();
  this.updateHearts();
  this.openSelector(handle); // 🔥 REQUIRED FOR LIVE UI
}


  toggleGift(handle) {
    this.wishlists.gifts ||= [];
    const list = this.wishlists.gifts;
    const i = list.indexOf(handle);

    if (i > -1) list.splice(i, 1);
    else list.push(handle);

    this.saveData();
    this.updateHearts();
    this.openSelector(handle);
  }

  /* ---------------------------
     ADD HORSE
  ---------------------------- */

  openAddHorse(handle) {
    const html = `
      <h3>Add Your Horse</h3>
      <form id="wishlist-add-horse-form">
        <input id="horse-name" placeholder="Horse name" required />
        <select id="horse-size">
          <option value="">Size (optional)</option>
          <option>Mini</option>
          <option>Pony</option>
          <option>Cob</option>
          <option>Full</option>
          <option>Draft</option>
        </select>
        <input type="date" id="horse-birthday" />
        <label id="horse-image-label">Upload a headshot of your horse</label>
        <input type="file" id="horse-image" accept="image/*" />
        <button class="btn-primary">Add Horse</button>
      </form>
    `;

    this.showModal(html);

    const nameInput = document.getElementById('horse-name');
    const label = document.getElementById('horse-image-label');

    nameInput.addEventListener('input', () => {
      label.textContent = nameInput.value
        ? `Upload a headshot of ${nameInput.value}`
        : 'Upload a headshot of your horse';
    });

    document.getElementById('wishlist-add-horse-form')
      .addEventListener('submit', e => this.saveHorse(e, handle));
  }

  saveHorse(e, handle) {
  e.preventDefault();

  const name = document.getElementById('horse-name').value;
  const size = document.getElementById('horse-size').value;
  const birthday = document.getElementById('horse-birthday').value;
  const fileInput = document.getElementById('horse-image');
  const file = fileInput.files[0];

  const finishSave = (imageData = null) => {
    const horse = {
      id: 'horse_' + Date.now(),
      name,
      size,
      birthday,
      image: imageData
    };

    this.horses.push(horse);
    this.wishlists[horse.id] = [handle];

    this.saveData();
    this.updateHearts();
    this.openSelector(handle); // 🔥 THIS IS THE KEY FIX
  };

  if (file) {
    const reader = new FileReader();
    reader.onload = () => finishSave(reader.result);
    reader.readAsDataURL(file);
  } else {
    finishSave();
  }
}


  /* ---------------------------
     UI HELPERS
  ---------------------------- */

  showModal(content) {
    this.closeModal();
    const m = document.createElement('div');
    m.className = 'wishlist-modal';
    m.innerHTML = `
      <div class="wishlist-modal-content">
        <button class="modal-close" onclick="horseWishlist.closeModal()">×</button>
        ${content}
      </div>`;
    document.body.appendChild(m);
  }

  closeModal() {
    document.querySelector('.wishlist-modal')?.remove();
  }

  showLoginPrompt() {
    this.showModal(`
      <h3>Create an Account</h3>
      <p>Sign in to save wishlists for your horses.</p>
      <a href="/account/login" class="btn-primary">Sign In</a>
    `);
  }

  /* ---------------------------
     ICONS
  ---------------------------- */

  plusIcon() {
    return `<svg class="wishlist-icon" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>`;
  }

  giftIcon() {
    return `<svg class="wishlist-icon" viewBox="0 0 24 24"><path d="M20 12v8H4v-8M2 7h20v5H2z"/><path d="M12 7v13"/></svg>`;
  }

  horseIcon() {
    return `<svg class="wishlist-icon" viewBox="0 0 24 24"><path d="M5 20l2-9 6-6 6 6 2 9"/></svg>`;
  }
}

/* INIT */
window.horseWishlist = new HorseWishlistSystem();

// When adding to wishlist
if (window.accountDashboard) {
  window.accountDashboard.trackActivity('wishlist_add', `Added ${productTitle} to wishlist`);
}

// When adding a horse
if (window.accountDashboard) {
  window.accountDashboard.trackActivity('horse_add', `Added horse: ${horse.name}`);
}